if (!customElements.get('cart-notes')) {
  class CartNotes extends HTMLElement {
    connectedCallback() {
      this.notes = this.querySelector('textarea[name="note"]');
      if (!this.notes) return;

      this.savedValue = this.notes.value;
      this.notes.addEventListener('input', debounce(() => this.saveNotes(), 400));
      this.notes.addEventListener('change', () => this.saveNotes());
    }

    saveNotes() {
      if (this.notes.value === this.savedValue) return;
      this.savedValue = this.notes.value;

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: this.notes.value
        })
      });
    }
  }
  customElements.define('cart-notes', CartNotes);
}
